// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import RecordTabsController from "./record_tabs_controller"
application.register("record-tabs", RecordTabsController)
